import { SingleInputConnectIntegrationFormDrawerContent } from '@modules/integrationsV2/components/AddIntegrationFormDrawerContent/SingleInputConnectIntegrationFormDrawerContent';
import { GetAddIntegrationFormDrawerContentProps } from '@modules/integrationsV2/utils/getAddIntegrationFormDrawerContent';
import { useState } from 'react';

export const FrontFormDrawerContent = ({
  integrationType,
  integrationChannel,
  onDrawerClose,
  integrationID,
}: GetAddIntegrationFormDrawerContentProps) => {
  const [accessToken, setAccessToken] = useState('');

  return (
    <SingleInputConnectIntegrationFormDrawerContent
      integrationID={integrationID}
      inputFieldData={accessToken}
      setInputFieldData={setAccessToken}
      integrationChannel={integrationChannel}
      integrationType={integrationType}
      integrationData={{
        front: {
          accessToken: accessToken,
        },
      }}
      updateAuthData={{
        front: {
          accessToken: accessToken,
        },
      }}
      textFieldProps={{
        label: 'Front Token',
        placeholder: 'Enter Front Token',
      }}
      onDrawerClose={onDrawerClose}
    />
  );
};
